import { Component, RefObject } from 'react';

import BlockContent from '@sanity/block-content-to-react';

import { Button } from 'components/base';
import { NotificationBarCloseIcon } from 'styled';
import { Container, Svg } from './style';

import Language from 'constants/Language';
import {
  ListItem,
  ExternalLink,
  InternalLink,
} from 'constants/PortableTextSerializer';

import { NotificationBar as INotificationBar } from 'types';

export interface Props {
  closeNotificationBar(): void;
  elemRef: RefObject<HTMLDivElement>;
  notificationBar: INotificationBar;
  notificationBarIsActive: boolean | null;
}

export interface State {
  removeWithAnimation: boolean;
}

class NotificationBar extends Component<Props, State> {
  state: State = {
    removeWithAnimation: false,
  };

  componentDidUpdate(prevProps: Props) {
    if (
      prevProps.notificationBarIsActive &&
      !this.props.notificationBarIsActive
    ) {
      this.setState({ removeWithAnimation: true });
    }
  }

  render() {
    const {
      closeNotificationBar,
      elemRef,
      notificationBar,
      notificationBarIsActive,
    } = this.props;
    const { removeWithAnimation } = this.state;

    return (
      <Container
        position="fixed"
        top="0"
        right="0"
        left="0"
        py={[1.25, 1.25, 1.25, 1]}
        px={[3, 3, 3, 4]}
        textAlign="center"
        aria-hidden={!notificationBarIsActive}
        ref={elemRef}
        notificationBarIsActive={notificationBarIsActive}
        removeWithAnimation={removeWithAnimation}
      >
        <BlockContent
          blocks={notificationBar.text}
          serializers={{
            listItem: ListItem,
            marks: { link: ExternalLink, internalLink: InternalLink },
          }}
        />
        <Button
          variant="notification-bar-close"
          ariaLabel={Language.t('NotificationBar.closeButtonAriaLabel')}
          onClick={closeNotificationBar}
        >
          <Svg as={NotificationBarCloseIcon} />
        </Button>
      </Container>
    );
  }
}

export default NotificationBar;
